function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2c27b827\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?sourceMap!./popularProducts.styl")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./popularProducts.js"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2c27b827\",\"hasScoped\":true}!./popularProducts.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c27b827",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/widgets/popularProducts/popularProducts.vue
// module id = 2749
// module chunks = 1